var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 12 16",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.22 3.47a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-4 4a.75.75 0 01-1.06-1.06L7.69 8 4.22 4.53a.75.75 0 010-1.06z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTIgMTYiIHdpZHRoPSIxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im00LjIxOTY3IDMuNDY5NjdjLjI5Mjg5LS4yOTI4OS43Njc3Ny0uMjkyODkgMS4wNjA2NiAwbDQgNGMuMjkyODkuMjkyODkuMjkyODkuNzY3NzcgMCAxLjA2MDY2bC00IDMuOTk5OTdjLS4yOTI4OS4yOTI5LS43Njc3Ny4yOTI5LTEuMDYwNjYgMHMtLjI5Mjg5LS43Njc3IDAtMS4wNjA2bDMuNDY5NjctMy40Njk3LTMuNDY5NjctMy40Njk2N2MtLjI5Mjg5LS4yOTI4OS0uMjkyODktLjc2Nzc3IDAtMS4wNjA2NnoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";
export { SvgChevronOutline16 as ReactComponent };